<template>
  <div class="my-events-container">
    <h1 class= "event-dashboard-header-note">Event Dashboard</h1>
    <h3 class="event-dashboard-subheader-note">A place to track all the events that you created</h3>
    <div class="create-event-container">
      <router-link to="/event/new/edit" class="create-event">
        Create a Event
      </router-link>
    </div>
    <table class="my-events-table">
      <thead>
        <tr class="event-dashboard-table-header">
          <th>Title</th>
          <th class="role">Role</th>
          <th>Status</th>
          <th class="date">Start Date</th>
          <th class="date">End Date</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <my-event-item v-for="(myEvent, i) in myEvents" :key="i"
          :id="myEvent._id"
          :title="myEvent.title"
          :startDate="myEvent.startDate"
          :endDate="myEvent.endDate"
          :status="myEvent.status"
          :role="getRole(myEvent)"
          @change="getAllMyEvents()"
        ></my-event-item>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import MyEventItem from '@/components/event/MyEventItem.vue';

export default {
  name: 'my-events',
  components: {
    MyEventItem,
  },
  data() {
    return {
      myEvents: [],
    };
  },
  async mounted() {
    await this.getAllMyEvents();
  },
  computed: {
    ...mapState('user', ['userName']),
    ...mapState('auth', ['backendAxios']),
  },
  methods: {
    ...mapActions('sponsorshipEvent', [
      'fetchEventRole', 'fetchEventStatus', 'fetchAllRoles', 'fetchAllStatuses',
    ]),
    async getAllMyEvents() {
      try {
        await Promise.all([
          this.fetchAllRoles(),
          this.fetchAllStatuses(),
        ]);
        const myEventsResponse = await this.backendAxios.get('/sponsorship-event/my-event');
        this.myEvents = myEventsResponse.data;
      } catch (err) {
        this.$toasted.show(err.response.data, {
          type: 'info',
          duration: 5000,
        });
      }
    },
    getRole(myEvent) {
      const teamMember = myEvent.team
        .find(member => member.user && member.user.userName === this.userName);
      if (!teamMember) {
        return null;
      }
      return teamMember.role;
    },
  },
};

</script>

<style lang="scss" scoped>
@import '@/assets/youpaired-colors.scss';

.my-events-table {
  border-bottom: 1px solid #e5e5e5;
  margin: 2rem auto 0 auto;
  text-align: left;
  width: 80%;
  font-size: 1rem;
  border-collapse: collapse;
  border-radius: 10px;
  overflow: hidden;

}

.my-events-table th {
  padding: 1rem 0.5rem 1rem 0.5rem;
}

.create-event-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 80%;
  margin: 0 auto;
}

.create-event {
  cursor: pointer;
  height: 1.5rem;
  padding: 0.5rem 1rem;
  border-radius: 0.2rem;
  color: #fff;
  background-color: $login-background;
  font-size: 1rem;
  border-color: $login-background;
  font-weight: 800;
  margin: 2rem 0 0 0rem;
  white-space: nowrap;
  letter-spacing: .025em;
  text-decoration: none;
  box-shadow: 0 4px 6px rgba(50,50,93,.11), 0 1px 3px rgba(0,0,0,.08);
   &:hover{
    background-color: $login-hover;
    border:none;
  }
}


.event-dashboard-table-header {
  height: 2.5rem;
  font-size: 1rem;
  font-weight: 900;
  border-radius: 0.5rem;
  background: #E8e8E8;
}

.my-events-container {
  text-align: center;
  overflow: auto;
  margin-bottom: 3rem;
}

.event-dashboard-header-note{
  margin-top: 2rem;
  line-height: 1rem;
}
.event-dashboard-subheader-note{
  line-height: 1rem;
  font-weight: 500
}

@media screen and (max-width: 768px) {
  .date {
    display: none
  }

  .my-events-table {
    width: 80%;
  }
}

@media screen and (max-width: 823px) {
  .date {
    display: none
  }
}

@media screen and (max-width: 350px) {
  .role {
    display: none
  }
}

</style>
